import { Palette } from '../constants/palette';
export const switchVariants = {
    sizes: {
        s: {
            height: '16px',
            width: '27px',
            padding: '1px',
            buttonSize: '14px',
        },
        m: {
            height: '24px',
            width: '40px',
            padding: '2px',
            buttonSize: '20px',
        },
        l: {
            height: '40px',
            width: '67px',
            padding: '3px',
            buttonSize: '34px',
        },
    },
    colorSchemes: {
        blue: {
            background: Palette.blue,
            slider: Palette.white,
            outline: Palette.goGreen,
        },
        green: {
            background: Palette.gray94,
            slider: Palette.goGreen,
            outline: Palette.blue,
        },
        white: {
            background: Palette.gray94,
            slider: Palette.blue,
            outline: Palette.goGreen,
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3dpdGNoLXZhcmlhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RoZW1lL3N3aXRjaC12YXJpYW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFHL0MsTUFBTSxDQUFDLE1BQU0sY0FBYyxHQUE0QjtJQUNyRCxLQUFLLEVBQUU7UUFDTCxDQUFDLEVBQUU7WUFDRCxNQUFNLEVBQUUsTUFBTTtZQUNkLEtBQUssRUFBRSxNQUFNO1lBQ2IsT0FBTyxFQUFFLEtBQUs7WUFDZCxVQUFVLEVBQUUsTUFBTTtTQUNuQjtRQUNELENBQUMsRUFBRTtZQUNELE1BQU0sRUFBRSxNQUFNO1lBQ2QsS0FBSyxFQUFFLE1BQU07WUFDYixPQUFPLEVBQUUsS0FBSztZQUNkLFVBQVUsRUFBRSxNQUFNO1NBQ25CO1FBQ0QsQ0FBQyxFQUFFO1lBQ0QsTUFBTSxFQUFFLE1BQU07WUFDZCxLQUFLLEVBQUUsTUFBTTtZQUNiLE9BQU8sRUFBRSxLQUFLO1lBQ2QsVUFBVSxFQUFFLE1BQU07U0FDbkI7S0FDRjtJQUNELFlBQVksRUFBRTtRQUNaLElBQUksRUFBRTtZQUNKLFVBQVUsRUFBRSxPQUFPLENBQUMsSUFBSTtZQUN4QixNQUFNLEVBQUUsT0FBTyxDQUFDLEtBQUs7WUFDckIsT0FBTyxFQUFFLE9BQU8sQ0FBQyxPQUFPO1NBQ3pCO1FBQ0QsS0FBSyxFQUFFO1lBQ0wsVUFBVSxFQUFFLE9BQU8sQ0FBQyxNQUFNO1lBQzFCLE1BQU0sRUFBRSxPQUFPLENBQUMsT0FBTztZQUN2QixPQUFPLEVBQUUsT0FBTyxDQUFDLElBQUk7U0FDdEI7UUFDRCxLQUFLLEVBQUU7WUFDTCxVQUFVLEVBQUUsT0FBTyxDQUFDLE1BQU07WUFDMUIsTUFBTSxFQUFFLE9BQU8sQ0FBQyxJQUFJO1lBQ3BCLE9BQU8sRUFBRSxPQUFPLENBQUMsT0FBTztTQUN6QjtLQUNGO0NBQ0YsQ0FBQyJ9